import { useQuery } from '@apollo/client'

import { GET_BRANCH_OFFICES, GET_RENTER_CARS } from '../../graphql/AdminQueries'

const GetBranchOffices = (graphqlVariables, loadData) => {
  const branchOffices = useQuery(GET_BRANCH_OFFICES, {
    variables: graphqlVariables,
    skip: !loadData
  })
  if (loadData && branchOffices?.data?.getBranchOficces) {
    return [branchOffices]
  }
  return undefined
}

const GetRenterCars = (graphqlVariables, loadData) => {
  const cars = useQuery(GET_RENTER_CARS, {
    variables: graphqlVariables,
    skip: !loadData
  })
  return [cars]
}

export { GetBranchOffices, GetRenterCars }
